/** Reloj de inactividad compartido por las pestañas de ABS en este navegador. */

export const LAST_ACTIVITY_KEY = "abs:lastActivity";

const MARK_GAP_MS = 1_000;
const PING_GAP_MS = 10_000;

let lastMarkAt = 0;
let lastPingAt = 0;
let pingTimer: ReturnType<typeof setTimeout> | null = null;
let pingFn: (() => Promise<void>) | null = null;

export function sessionLimitMs(minutes: unknown): number {
  const n = typeof minutes === "number" ? minutes : Number(minutes);
  const mins = Number.isFinite(n) && n > 0 ? n : 15;
  return mins * 60_000;
}

export function idleExceeded(lastActivityMs: number, now: number, limitMs: number): boolean {
  if (!lastActivityMs) return false;
  return now - lastActivityMs >= limitMs;
}

export function shouldRefreshAccess(
  remainingMs: number,
  idleSoFarMs: number,
  limitMs: number,
): boolean {
  if (idleSoFarMs >= limitMs) return false;
  if (remainingMs <= 0) return true;
  const threshold = Math.min(20_000, Math.max(5_000, Math.floor(limitMs / 4)));
  return remainingMs < threshold;
}

export function markSessionStarted(now = Date.now()): void {
  lastMarkAt = now;
  lastPingAt = now;
  localStorage.setItem(LAST_ACTIVITY_KEY, String(now));
}

export function readLastActivity(now = Date.now()): number {
  const raw = Number(localStorage.getItem(LAST_ACTIVITY_KEY));
  if (!Number.isFinite(raw) || raw <= 0) {
    localStorage.setItem(LAST_ACTIVITY_KEY, String(now));
    return now;
  }
  return raw;
}

export function bindActivityPing(fn: () => Promise<void>): void {
  pingFn = fn;
}

export function noteActivity(now = Date.now()): void {
  if (now - lastMarkAt < MARK_GAP_MS) return;
  lastMarkAt = now;
  localStorage.setItem(LAST_ACTIVITY_KEY, String(now));
  const wait = PING_GAP_MS - (now - lastPingAt);
  if (wait <= 0) {
    void sendPing();
    return;
  }
  if (pingTimer != null) return;
  pingTimer = setTimeout(() => {
    pingTimer = null;
    void sendPing();
  }, wait);
}

export async function flushActivityPing(): Promise<void> {
  if (pingTimer != null) {
    clearTimeout(pingTimer);
    pingTimer = null;
  }
  const last = Number(localStorage.getItem(LAST_ACTIVITY_KEY) || 0);
  if (last > lastPingAt) await sendPing();
}

export function resetIdleTimers(): void {
  lastMarkAt = 0;
  lastPingAt = 0;
  pingFn = null;
  if (pingTimer != null) {
    clearTimeout(pingTimer);
    pingTimer = null;
  }
}

async function sendPing(): Promise<void> {
  lastPingAt = Date.now();
  try {
    await pingFn?.();
  } catch {
    /* un 401 lo resuelve el cliente HTTP */
  }
}
